import { ImageType } from '@inter-ikea-storageone/range';
import { GalleryConfig } from 'rangeConfig/@types';

const billyGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-69287392' },
        { id: 'SPR-59483275' },
        { id: 'SPR-29487840' },
        { id: 'SPR-19483588' },
        { id: 'SPR-09483367' },
        { id: 'SPR-39563131' },
        { id: 'SPR-59017838' },
        { id: 'SPR-69217714' },
        { id: 'SPR-49280754' },
        { id: 'SPR-39571391' },
        { id: 'SPR-29570373' },
        { id: 'SPR-09581551' },
        { id: 'SPR-39581516', image: { index: 0, type: ImageType.FPP } },
        { id: 'SPR-39581559', image: { index: 0, type: ImageType.FPP } },
        { id: 'SPR-19581522' }
      ]
    }
  ]
};

export default billyGalleryConfig;
